import {Dictionary} from '../dictionaries/model';

export const dictionaryPipe = (key: string, dictionary: Dictionary): string => {
  return dictionary[key] || '';
};
